(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["analytics-bridge"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.GESAnalyticsBridge) return;

    var BRIDGE_SOURCE = 'ges-shopify-pixel';
    var BRIDGE_VERSION = 1;
    var DEDUPE_TTL = 30000;
    var recentEvents = {};
    var configScript = document.querySelector('[data-ges-analytics-config]');
    var config = {};

    try {
      config = configScript ? JSON.parse(configScript.textContent) : {};
    } catch (error) {
      config = {};
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    var allowedEvents = {
      page_view: true,
      view_item: true,
      view_item_list: true,
      select_item: true,
      view_search_results: true,
      add_to_cart: true,
      remove_from_cart: true,
      view_cart: true,
      begin_checkout: true,
      add_shipping_info: true,
      add_payment_info: true,
      purchase: true,
      generate_lead: true,
      file_download: true,
      view_promotion: true,
      select_promotion: true,
      login: true,
      sign_up: true
    };

    var customEventMap = {
      ges_contact_click: 'generate_lead',
      ges_contact_form_submitted: 'generate_lead',
      ges_quote_cta_clicked: 'generate_lead',
      ges_document_downloaded: 'file_download',
      ges_promotion_viewed: 'view_promotion',
      ges_promotion_clicked: 'select_promotion',
      ges_product_card_clicked: 'select_item',
      ges_customer_login_submitted: 'login',
      ges_customer_register_submitted: 'sign_up'
    };

    var allowedPayloadKeys = {
      event: true,
      event_source: true,
      event_id: true,
      page_location: true,
      page_title: true,
      page_referrer: true,
      content_group: true,
      currency: true,
      value: true,
      tax: true,
      shipping: true,
      coupon: true,
      transaction_id: true,
      shipping_tier: true,
      search_term: true,
      item_list_id: true,
      item_list_name: true,
      lead_type: true,
      form_name: true,
      form_subject: true,
      contact_method: true,
      cta_location: true,
      file_name: true,
      file_url: true,
      document_kind: true,
      product_handle: true,
      promotion_id: true,
      promotion_name: true,
      creative_name: true,
      creative_slot: true,
      method: true,
      items: true
    };

    var allowedItemKeys = {
      item_id: true,
      item_name: true,
      item_brand: true,
      item_category: true,
      item_variant: true,
      item_list_id: true,
      item_list_name: true,
      price: true,
      quantity: true,
      discount: true,
      coupon: true
    };

    function primitive(value) {
      return value == null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
    }

    function sanitizeString(value, limit) {
      if (value == null) return undefined;
      return String(value).replace(/[\r\n\t]+/g, ' ').trim().slice(0, limit || 240);
    }

    function sanitizeItem(item) {
      var clean = {};
      if (!item || typeof item !== 'object') return clean;

      Object.keys(allowedItemKeys).forEach(function (key) {
        if (primitive(item[key])) {
          clean[key] = typeof item[key] === 'string' ? sanitizeString(item[key], 240) : item[key];
        }
      });

      return clean;
    }

    function sanitizePayload(payload) {
      var clean = {};
      if (!payload || typeof payload !== 'object') return clean;

      Object.keys(allowedPayloadKeys).forEach(function (key) {
        if (key === 'items') {
          if (Array.isArray(payload.items)) {
            clean.items = payload.items.map(sanitizeItem).filter(function (item) {
              return Object.keys(item).length > 0;
            });
          }
          return;
        }

        if (primitive(payload[key])) {
          clean[key] = typeof payload[key] === 'string' ? sanitizeString(payload[key], 500) : payload[key];
        }
      });

      return clean;
    }

    function contentGroupFromUrl(url) {
      var path;

      try {
        path = new URL(url || window.location.href, window.location.origin).pathname;
      } catch (error) {
        path = window.location.pathname;
      }

      if (path.indexOf('/products/') === 0) return 'product';
      if (path.indexOf('/collections/') === 0) return 'collection';
      if (path === '/pages/contact' || path === '/pages/contact-us') return 'contact';
      if (path === '/cart') return 'cart';
      if (path.indexOf('/checkouts/') === 0 || path.indexOf('/checkout') === 0) return 'checkout';
      if (path === '/search') return 'search';
      if (path.indexOf('/account') === 0 || path.indexOf('/customers/') === 0) return 'account';

      return 'other';
    }

    function pageContext() {
      return {
        page_location: window.location.href,
        page_title: document.title,
        page_referrer: document.referrer,
        content_group: contentGroupFromUrl(window.location.href)
      };
    }

    function locationFromElement(element) {
      if (!element) return 'page';
      if (element.closest('.site-header')) return 'header';
      if (element.closest('.site-footer')) return 'footer';
      if (element.closest('.contact-template')) return 'contact';
      if (element.closest('.location-map')) return 'location_map';
      if (element.closest('.quote-popup')) return 'quote_popup';
      if (element.closest('.cart-drawer')) return 'cart_drawer';
      if (element.closest('.cart-template')) return 'cart';
      if (element.closest('.customer-auth')) return 'account';
      if (element.closest('.product-template')) return 'product';

      return 'page';
    }

    function eventId(name) {
      return [
        name,
        Date.now(),
        Math.random().toString(36).slice(2, 10)
      ].join(':');
    }

    function isDuplicate(name, id) {
      var key = name + ':' + id;
      var now = Date.now();

      if (!id) return false;

      Object.keys(recentEvents).forEach(function (eventKey) {
        if (now - recentEvents[eventKey] > DEDUPE_TTL) delete recentEvents[eventKey];
      });

      if (recentEvents[key]) return true;
      recentEvents[key] = now;

      return false;
    }

    function isAllowedOrigin(origin) {
      var shopDomain = config.shopDomain;

      // Shopify's sandboxed pixel iframe posts with a null origin; source/version/type checks below mitigate spoofing
      if (!origin || origin === 'null') return true;

      try {
        var parsed = new URL(origin);
        if (parsed.origin === window.location.origin) return true;
        if (shopDomain && parsed.hostname === shopDomain) return true;
      } catch (error) {
        return false;
      }

      return false;
    }

    function sendGa4Event(payload) {
      var params = {};

      if (!payload || !payload.event || typeof window.gtag !== 'function') return;

      Object.keys(payload).forEach(function (key) {
        if (key !== 'event') {
          params[key] = payload[key];
        }
      });

      if (config.ga4MeasurementId) {
        params.send_to = config.ga4MeasurementId;
      }

      window.gtag('event', payload.event, params);
    }

    function pushDataLayer(payload, options) {
      var clean = sanitizePayload(payload);

      if (!clean.event || !allowedEvents[clean.event]) return;
      if (isDuplicate(clean.event, clean.event_id)) return;

      if (!clean.page_location) clean.page_location = window.location.href;
      if (!clean.page_title) clean.page_title = document.title;
      if (!clean.page_referrer) clean.page_referrer = document.referrer;
      if (!clean.content_group) clean.content_group = contentGroupFromUrl(clean.page_location);

      window.dataLayer.push(clean);

      if (options && options.sendToGa4) {
        sendGa4Event(clean);
      }

      return clean;
    }

    function publishCustomerEvent(name, payload) {
      var customData = Object.assign({}, pageContext(), payload || {}, {
        event_source: 'shopify_theme',
        event_id: eventId(name)
      });

      if (config.directGa4Events) {
        customData.event = customEventMap[name];
        pushDataLayer(customData, { sendToGa4: true });
        return;
      }

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, customData);
        return;
      }

      customData.event = customEventMap[name];
      pushDataLayer(customData);
    }

    function consentValue(isAllowed) {
      return isAllowed ? 'granted' : 'denied';
    }

    function getConsentState() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var analyticsAllowed = false;
      var marketingAllowed = false;
      var preferencesAllowed = false;

      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
        return null;
      }

      analyticsAllowed = privacy.analyticsProcessingAllowed();

      if (typeof privacy.marketingAllowed === 'function') {
        marketingAllowed = privacy.marketingAllowed();
      }
      if (typeof privacy.preferencesProcessingAllowed === 'function') {
        preferencesAllowed = privacy.preferencesProcessingAllowed();
      }

      return {
        analytics_storage: consentValue(analyticsAllowed),
        ad_storage: consentValue(marketingAllowed),
        ad_user_data: consentValue(marketingAllowed),
        ad_personalization: consentValue(marketingAllowed),
        functionality_storage: consentValue(preferencesAllowed),
        personalization_storage: consentValue(preferencesAllowed),
        security_storage: 'granted'
      };
    }

    function updateConsent(command) {
      if (!config.manageGoogleConsent) return;

      var state = getConsentState();
      if (!state) return;

      var payload = Object.assign({}, state);

      if (command === 'default') {
        payload.wait_for_update = 500;
      }

      window.gtag('consent', command, payload);
      window.dataLayer.push(Object.assign({
        event: 'shopify_consent_' + command,
        event_source: 'shopify_customer_privacy'
      }, state));
    }

    function fileNameFromUrl(url) {
      try {
        return decodeURIComponent(new URL(url, window.location.origin).pathname.split('/').pop() || '');
      } catch (error) {
        return '';
      }
    }

    function productHandleFromUrl(url) {
      var match = String(url || '').match(/\/products\/([^/?#]+)/);
      return match ? match[1] : undefined;
    }

    function documentKindFromLink(link) {
      var text = sanitizeString(link.textContent || '', 80).toLowerCase();
      if (text.indexOf('manual') !== -1) return 'manual';
      if (text.indexOf('parts') !== -1) return 'parts';
      if (text.indexOf('spec') !== -1) return 'spec';
      return 'document';
    }

    function itemListNameFromElement(element) {
      if (!element) return 'product_list';
      if (element.closest('.featured-products')) return 'featured_products';
      if (element.closest('.smart-recommended-products')) return 'recommended_products';
      if (element.closest('.search-template')) return 'search_results';
      if (element.closest('.collection-template')) return 'collection';
      if (element.closest('.related-swiper')) return 'related_products';
      return 'product_list';
    }

    function handleBridgeMessage(event) {
      var message = event.data;

      if (!message || typeof message !== 'object') return;
      if (message.source !== BRIDGE_SOURCE || message.version !== BRIDGE_VERSION || message.type !== 'ga4_event') return;
      if (!isAllowedOrigin(event.origin)) return;
      if (!message.payload || typeof message.payload !== 'object') return;

      pushDataLayer(Object.assign({}, message.payload, {
        event_id: message.payload.event_id || message.event_id
      }));
    }

    function handleClick(event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('a, button') : null;
      var quoteLink = target && target.closest ? target.closest('.quote-popup__button') : null;
      var documentLink = target && target.closest ? target.closest('.product-template__document-link') : null;
      var promoLink = target && target.closest ? target.closest('.spring-sale-features__button, .featured-product-card__sale-tag') : null;
      var productCardLink = target && target.closest ? target.closest('.featured-product-card__media, .featured-product-card__title a, .featured-product-card__button') : null;

      if (!link) return;

      if (quoteLink) {
        publishCustomerEvent('ges_quote_cta_clicked', {
          lead_type: 'quote_request',
          cta_location: 'quote_popup'
        });
      }

      if (documentLink) {
        publishCustomerEvent('ges_document_downloaded', {
          file_name: fileNameFromUrl(documentLink.href),
          file_url: documentLink.href,
          document_kind: documentKindFromLink(documentLink),
          product_handle: productHandleFromUrl(window.location.href),
          cta_location: 'product_documents'
        });
      }

      if (promoLink) {
        publishCustomerEvent('ges_promotion_clicked', {
          promotion_name: promoLink.closest('.spring-sale-features') ? 'spring_sale_features' : 'product_sale_tag',
          creative_slot: locationFromElement(promoLink),
          cta_location: locationFromElement(promoLink)
        });
      }

      if (productCardLink) {
        var productCardAnchor = productCardLink.tagName === 'A' ? productCardLink : productCardLink.closest('a');
        publishCustomerEvent('ges_product_card_clicked', {
          item_list_name: itemListNameFromElement(productCardLink),
          product_handle: productHandleFromUrl(productCardAnchor && productCardAnchor.href),
          cta_location: locationFromElement(productCardLink)
        });
      }

      if (link.matches('a[href^="tel:"]')) {
        publishCustomerEvent('ges_contact_click', {
          lead_type: 'contact',
          contact_method: 'phone',
          cta_location: locationFromElement(link)
        });
      }

      if (link.matches('a[href^="mailto:"]')) {
        publishCustomerEvent('ges_contact_click', {
          lead_type: 'contact',
          contact_method: 'email',
          cta_location: locationFromElement(link)
        });
      }

      if (link.matches('a[href*="google.com/maps"]')) {
        publishCustomerEvent('ges_contact_click', {
          lead_type: 'directions',
          contact_method: 'directions',
          cta_location: locationFromElement(link)
        });
      }
    }

    function handleSubmit(event) {
      var form = event.target;
      var subject = form.querySelector('select[name="contact[Inquiry type]"]');

      if (form.matches('.contact-template__form')) {
        publishCustomerEvent('ges_contact_form_submitted', {
          lead_type: 'contact_form',
          form_name: 'contact',
          form_subject: subject ? sanitizeString(subject.value, 80) : undefined,
          cta_location: 'contact_form'
        });
      }

      if (form.querySelector('#CustomerEmail') && form.querySelector('#CustomerPassword')) {
        publishCustomerEvent('ges_customer_login_submitted', {
          method: 'customer_account'
        });
      }

      if (form.querySelector('#RegisterEmail') && form.querySelector('#RegisterPassword')) {
        publishCustomerEvent('ges_customer_register_submitted', {
          method: 'customer_account'
        });
      }
    }

    function observePromotions() {
      var targets = document.querySelectorAll('.spring-sale-features, .featured-product-card__sale-tag');
      var seen = {};

      if (!('IntersectionObserver' in window) || targets.length === 0) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var target = entry.target;
          var name = target.matches('.spring-sale-features') ? 'spring_sale_features' : 'product_sale_tag';
          var key = name + ':' + Array.prototype.indexOf.call(targets, target);

          if (seen[key]) return;
          seen[key] = true;

          publishCustomerEvent('ges_promotion_viewed', {
            promotion_name: name,
            creative_slot: locationFromElement(target)
          });

          observer.unobserve(target);
        });
      }, { threshold: 0.5 });

      targets.forEach(function (target) {
        observer.observe(target);
      });
    }

    updateConsent('update');
    document.addEventListener('visitorConsentCollected', function () {
      updateConsent('update');
    });
    document.addEventListener('customerPrivacyApiLoaded', function () {
      updateConsent('update');
    });
    window.addEventListener('message', handleBridgeMessage);
    document.addEventListener('click', handleClick);
    document.addEventListener('submit', handleSubmit);

    observePromotions();

    window.GESAnalyticsBridge = {
      publish: publishCustomerEvent,
      pushDataLayer: pushDataLayer,
      contentGroupFromUrl: contentGroupFromUrl,
      updateConsent: function () {
        updateConsent('update');
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCartDrawer() {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;

    var panel = drawer.querySelector('[data-cart-drawer-panel]');
    var content = drawer.querySelector('[data-cart-drawer-content]');
    var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
    var form = drawer.querySelector('[data-cart-drawer-form]');
    var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    var noteField = drawer.querySelector('textarea[name="note"]');
    var leadTimeDataScript = document.querySelector('[data-cart-drawer-lead-times]');
    var leadTimeByKey = {};
    var previousFocus = null;
    var focusableSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    if (leadTimeDataScript) {
      try {
        leadTimeByKey = JSON.parse(leadTimeDataScript.textContent || '{}');
      } catch (error) {
        leadTimeByKey = {};
      }
    }

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(drawer.dataset.locale || 'en-US', {
          style: 'currency',
          currency: drawer.dataset.currency || 'USD'
        }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char];
      });
    }

    var equivalentLeadTimeSkus = [
      'Knaack 119-01',
      'Knaack 69',
      'Knaack 69 w/ casters',
      'Knaack 90',
      'Knaack 89 OS',
      'Knaack 89 Original Casters out-of-stock',
      'Knaack 109',
      'Knaack 139',
      'Greenlee 8060DLX',
      'Greenlee 4872',
      'Jobox 1-674990',
      'Jobox 1-674990 with Casters',
      'Jobox 2-688990'
    ];

    function getLineProperty(item, key) {
      if (!item || !item.properties) return '';
      return item.properties[key] || '';
    }

    function getDrawerLeadTime(item) {
      var isEquivalent = equivalentLeadTimeSkus.indexOf(item.sku) !== -1 || getLineProperty(item, '_ges_equivalent_lead_time') === 'true';
      if (isEquivalent && Number(item.quantity || 0) > 2) return '30 Business Days';
      return getLineProperty(item, '_ges_default_lead_time') || leadTimeByKey[item.key] || '';
    }

    function setMarkup(container, markup) {
      if (!container) return;
      var template = document.createElement('template');
      template.innerHTML = markup;
      container.replaceChildren(template.content);
    }

    function buildItemMarkup(item, index) {
      var cartUrl = drawer.dataset.cartUrl || '/cart';
      var packageIcon = drawer.dataset.packageIcon || '';
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" class="cart-drawer__item-image" loading="lazy" decoding="async" width="76" height="76">'
        : '<span class="cart-drawer__item-placeholder" aria-hidden="true">' + packageIcon + '</span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span>' + escapeHtml(item.variant_title) + '</span>' : '';
      var sku = item.sku ? '<span>SKU ' + escapeHtml(item.sku) + '</span>' : '';
      var leadTime = getDrawerLeadTime(item);
      var leadTimeMarkup = leadTime
        ? '<p class="cart-drawer__item-lead-time"><i class="ph ph-clock" aria-hidden="true"></i><span><strong>Lead time:</strong> ' + escapeHtml(leadTime) + '</span></p>'
        : '';

      return [
        '<article class="cart-drawer__item" data-cart-drawer-item>',
        '<a href="' + escapeHtml(item.url) + '" class="cart-drawer__item-media" aria-label="' + escapeHtml(item.product_title) + '">' + image + '</a>',
        '<div class="cart-drawer__item-copy">',
        '<div class="cart-drawer__item-heading">',
        '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></h3>',
        '<a href="' + cartUrl + '/change?line=' + (index + 1) + '&quantity=0" class="cart-drawer__remove" aria-label="Remove ' + escapeHtml(item.product_title) + '" data-cart-drawer-remove="' + index + '"><i class="ph ph-trash" aria-hidden="true"></i></a>',
        '</div>',
        '<div class="cart-drawer__item-meta">' + variant + sku + '</div>',
        leadTimeMarkup,
        '<div class="cart-drawer__item-bottom">',
        '<label class="cart-drawer__quantity"><span>Quantity</span><input type="number" name="updates[]" value="' + item.quantity + '" min="0" inputmode="numeric" data-cart-drawer-quantity></label>',
        '<strong>' + formatMoney(item.final_line_price) + '</strong>',
        '</div>',
        '</div>',
        '</article>'
      ].join('');
    }

    function buildItemsMarkup(cart) {
      return cart.items.map(buildItemMarkup).join('');
    }

    function renderCart(cart) {
      var focusedQuantityIndex = -1;
      var scrollTop = itemsContainer ? itemsContainer.scrollTop : 0;
      var activeElement = document.activeElement;
      var shouldRestoreFocus = activeElement && itemsContainer && itemsContainer.contains(activeElement);

      if (!cart || cart.item_count === 0) {
        if (emptyState) emptyState.hidden = false;
        if (form) form.hidden = true;
        if (itemsContainer) setMarkup(itemsContainer, '');
        if (subtotalEl) subtotalEl.textContent = formatMoney(0);
        if (noteField) noteField.value = '';
        updateBadges(0);
        return;
      }

      if (shouldRestoreFocus && activeElement.matches('[data-cart-drawer-quantity]')) {
        focusedQuantityIndex = Array.prototype.indexOf.call(itemsContainer.querySelectorAll('[data-cart-drawer-quantity]'), activeElement);
      }

      if (emptyState) emptyState.hidden = true;
      if (form) form.hidden = false;
      if (itemsContainer) {
        setMarkup(itemsContainer, buildItemsMarkup(cart));
        itemsContainer.scrollTop = scrollTop;
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      if (noteField && typeof cart.note === 'string') noteField.value = cart.note;
      if (focusedQuantityIndex > -1 && itemsContainer) {
        var updatedQuantityInput = itemsContainer.querySelectorAll('[data-cart-drawer-quantity]')[focusedQuantityIndex];
        if (updatedQuantityInput) updatedQuantityInput.focus();
      }

      updateBadges(cart.item_count);
    }

    function updateBadges(count) {
      document.querySelectorAll('.site-header__cart-badge').forEach(function (badge) {
        badge.textContent = count;
        badge.setAttribute('aria-label', count + ' items in cart');
        badge.hidden = count === 0;
      });
    }

    function fetchCart() {
      return fetch((drawer.dataset.cartUrl || '/cart') + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      });
    }

    function refresh() {
      return fetchCart().then(renderCart);
    }

    function openDrawer() {
      previousFocus = document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-is-open');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var firstClose = drawer.querySelector('[data-cart-drawer-close]');
        (firstClose || panel).focus();
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-is-open');
      window.setTimeout(function () {
        drawer.hidden = true;
        if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      }, 220);
    }

    function trapFocus(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = Array.prototype.slice.call(drawer.querySelectorAll(focusableSelector)).filter(function (element) {
        return element.offsetParent !== null;
      });
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function updateCartFromForm(form) {
      return fetch((drawer.dataset.cartUrl || '/cart') + '/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      }).then(renderCart);
    }

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var remove = event.target.closest('[data-cart-drawer-remove]');
      if (remove) {
        event.preventDefault();
        var form = drawer.querySelector('[data-cart-drawer-form]');
        var index = Number(remove.getAttribute('data-cart-drawer-remove'));
        var inputs = form ? form.querySelectorAll('[data-cart-drawer-quantity]') : [];
        if (inputs[index]) {
          inputs[index].value = 0;
          updateCartFromForm(form);
        }
      }
    });

    drawer.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-cart-drawer-form]');
      if (!form) return;

      var submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') return;

      event.preventDefault();
      updateCartFromForm(form);
    });

    drawer.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-drawer-quantity]')) return;
      var form = event.target.closest('[data-cart-drawer-form]');
      if (form) updateCartFromForm(form);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-drawer-trigger]');
      if (!trigger) return;
      event.preventDefault();
      refresh().finally(openDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.hidden) trapFocus(event);
    });

      window.ConexseggCartDrawer = {
        open: openDrawer,
        close: closeDrawer,
        refresh: refresh,
        refreshAndOpen: function () {
          return refresh().finally(openDrawer);
        },
        handleAdd: function (form) {
          return fetch(form.action, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          }).then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          }).then(function () {
            return refresh();
          }).then(openDrawer);
        }
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawer);
    } else {
      initCartDrawer();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    var nav = document.getElementById('site-nav');
    if (!nav) return;

    var panelsEl = document.getElementById('site-nav-panels');
    var categoryBar = nav.querySelector('.site-nav__bar');
    var triggers = nav.querySelectorAll('[data-panel-trigger]');
    var panels = panelsEl ? panelsEl.querySelectorAll('.site-nav__panel') : [];
    var mobileToggle = nav.querySelector('[data-mobile-nav-toggle]');
    var activeId = null;
    var closeTimer = null;
    var desktopMenu = window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)');

    function usesDesktopHover() {
      return desktopMenu.matches;
    }

    function cancelClose() {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(closeAll, 180);
    }

    function closeAll() {
      panels.forEach(function (p) { p.hidden = true; });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      activeId = null;
    }

    function closeMobileMenu() {
      nav.classList.remove('is-open');
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      closeAll();
    }

    function toggleMobileMenu() {
      var isOpen = nav.classList.toggle('is-open');
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (!isOpen) closeAll();
    }

    function openPanel(id, trigger) {
      cancelClose();
      if (activeId === id) return;

      panels.forEach(function (p) { p.hidden = true; });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });

      var panel = document.getElementById('panel-' + id);
      if (!panel) return;

      if (panel.classList.contains('site-nav__panel--dropdown') && usesDesktopHover()) {
        var tRect = trigger.getBoundingClientRect();
        var nRect = nav.getBoundingClientRect();
        panel.style.left = Math.max(0, tRect.left - nRect.left) + 'px';
        panel.style.top = '-' + (categoryBar ? categoryBar.offsetHeight : 0) + 'px';
      } else {
        panel.style.left = '';
        panel.style.top = '';
      }

      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      activeId = id;
    }

    nav.addEventListener('mouseleave', function () {
      if (!usesDesktopHover()) return;
      scheduleClose();
    });

    triggers.forEach(function (trigger) {
      var id = trigger.dataset.panelTrigger;

      trigger.addEventListener('mouseenter', function () {
        if (!usesDesktopHover()) return;
        cancelClose();
        openPanel(id, trigger);
      });

      trigger.addEventListener('click', function (e) {
        activeId === id ? closeAll() : openPanel(id, trigger);
        e.stopPropagation();
      });
    });

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        toggleMobileMenu();
      });
    }

    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () {
        if (!usesDesktopHover()) return;
        cancelClose();
      });
      panel.addEventListener('mouseleave', function () {
        if (!usesDesktopHover()) return;
        scheduleClose();
      });
    });

    if (desktopMenu.addEventListener) {
      desktopMenu.addEventListener('change', function () {
        closeAll();
        if (usesDesktopHover()) {
          nav.classList.remove('is-open');
          if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
        }
      });
    } else if (desktopMenu.addListener) {
      desktopMenu.addListener(function () {
        closeAll();
        if (usesDesktopHover()) {
          nav.classList.remove('is-open');
          if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeId) {
        var t = nav.querySelector('[data-panel-trigger="' + activeId + '"]');
        closeAll();
        if (t) t.focus();
      } else if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMobileMenu();
        if (mobileToggle) mobileToggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeMobileMenu();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
